export const FIAT_WITHDRAW_INIT = `/api/v1/financial-coordinator/toman/withdraw/trx/init`;
